import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X7PushableBlockStore} from '../X7PushableBlockStore';

@observer
export class ReorderBlocksControls extends React.Component<{ store: X7PushableBlockStore }> {
  render() {
    const {store} = this.props;

    if (store.reorderBlocks === null)
      return null;

    const reorder = store.reorderBlocks;
    const isLoading = reorder.save?.isPending === true;

    return (
      <>
        <div className="row justify-content-end">
          <div className="col-auto">
            <button type="button"
                    className="btn btn-primary"
                    onClick={store.completeReorderBlocks}
                    disabled={isLoading}>
              Save
            </button>
            <button type="button"
                    className="btn btn-primary"
                    onClick={store.cancel}
                    disabled={isLoading}>
              Cancel
            </button>
          </div>
        </div>

        <PromiseMessage label="Saving" state={reorder.save} align="right"/>
      </>
    );
  }
}
